/* Mewpouch v2 overrides: gift values, FREE styling, video wall */
(function(){
  var V = {12:22, 11:18, 13:21, 9:17};
  GIFTS.forEach(function(g){ if (V[g.v]) g.v = V[g.v]; });
  TIERS[2].giftVal = 40;
  TIERS[3].giftVal = 78;

  window.buildBundle = function(){
    var b=document.getElementById('bundle'); b.innerHTML='';
    var RIB={2:'MOST POPULAR &mdash; <em>SAVE 45% + 2 FREE GIFTS</em>',
             3:'BEST VALUE &mdash; <em>SAVE 48% + 4 FREE GIFTS</em>'};
    [1,2,3].forEach(function(q){
      var t=TIERS[q], per=t.price/q, gifts=GIFTS.slice(0,t.gifts), ben=[];
      if(t.price>=FREE_SHIP) ben.push('Free shipping included');
      if(t.gifts) ben.push(t.gifts+' cat gifts — <s>$'+t.giftVal+'</s> <b style="color:var(--good)">FREE</b>');
      if(q===3) ben.push('Lowest price per hoodie');
      ben.push('30-day money-back guarantee');
      var h='';
      if(RIB[q]) h+='<span class="ribbon">'+RIB[q]+'</span>';
      h+='<span class="tinner"><span class="trow"><span class="radio"></span>'+
         '<span class="tmain"><span class="tname">'+
         (q===1?'One hoodie':q===2?'Two hoodies':'Three hoodies')+'</span>'+
         '<span class="tsub">'+money(per)+' each</span></span>'+
         '<span class="tprice"><span class="tnow">'+money(t.price)+'</span>'+
         '<span class="twas">'+money(t.was)+'</span></span></span>'+
         '<ul class="tben">'+ben.map(function(x){return '<li>'+x+'</li>'}).join('')+'</ul>';
      if(gifts.length){
        h+='<span class="gpanel"><span class="ghead">Your free gifts'+
           '<span class="gval"><s>$'+t.giftVal+'</s> FREE</span></span><span class="ggrid">'+
           gifts.map(function(g){
             return '<span class="gitem"><span class="gpill">FREE $'+g.v+'</span>'+
                    '<img src="'+g.i+'" alt="'+g.n+'" loading="lazy">'+
                    '<span class="gname">'+g.n+'</span></span>';
           }).join('')+'</span></span>';
      } else {
        h+='<span class="tnote">Add '+money(FREE_SHIP-t.price)+' more to unlock free shipping &amp; 2 free gifts</span>';
      }
      h+='</span>';
      var el=document.createElement('button');
      el.className='btier'; el.dataset.qty=q;
      el.setAttribute('aria-pressed', q===state.tier?'true':'false');
      el.innerHTML=h;
      el.onclick=function(){ setTier(q) };
      b.appendChild(el);
    });
  };

  window.buildOffer = function(){
    var w=document.getElementById('ocards'); if(!w) return;
    w.innerHTML='';
    var HEAD={1:'STARTER',2:'MOST POPULAR',3:'BEST VALUE'};
    [1,2,3].forEach(function(q){
      var t=TIERS[q], per=t.price/q, gifts=GIFTS.slice(0,t.gifts);
      var d=document.createElement('div');
      d.className='ocard'+(q===3?' best':'');
      d.innerHTML='<div class="oh">'+HEAD[q]+'</div><div class="ob">'+
        '<div class="oq">'+q+' hoodie'+(q>1?'s':'')+'</div>'+
        '<div class="op">'+money(per)+'</div>'+
        '<div class="oe">each &middot; '+money(t.price)+' total</div>'+
        '<div class="ow">'+money(t.was)+'</div>'+
        (gifts.length
          ? '<div class="og">'+gifts.map(function(g){return '<img src="'+g.i+'" alt="'+g.n+'" loading="lazy">'}).join('')+'</div>'+
            '<div class="ogl">+ '+t.gifts+' gifts <s style="opacity:.65">$'+t.giftVal+'</s> FREE</div>'
          : '<div class="oe" style="margin-top:8px">No free gifts at this tier</div>')+
        '<button class="obtn">'+(q===state.tier?'Selected':'Choose this')+'</button></div>';
      d.querySelector('.obtn').onclick=function(){
        setTier(q); buildOffer();
        document.querySelector('.cta-1').scrollIntoView({behavior:'smooth',block:'center'});
      };
      w.appendChild(d);
    });
  };

  window.render = function(){
    var t=TIERS[state.tier], tot=total(), per=t.price/state.tier;
    var pct=Math.round((UNIT_RRP-per)/UNIT_RRP*100);
    document.getElementById('pNow').innerHTML=money(per)+'<span class="peach">each</span>';
    document.getElementById('pWas').textContent=money(UNIT_RRP);
    document.getElementById('pBadge').textContent='SAVE '+pct+'%';
    document.getElementById('gSave').textContent='SAVE '+pct+'%';
    document.getElementById('pUnit').innerHTML=state.tier+' hoodie'+(state.tier>1?'s':'')+
      ' &mdash; <b>'+money(t.price)+'</b> total'+
      (t.gifts?' &middot; <b>'+t.gifts+' gifts <s style="opacity:.6">$'+t.giftVal+'</s> FREE</b>':'');
    document.getElementById('ctaPrice').textContent=money(tot);
    document.getElementById('satcPrice').textContent=money(tot);
    document.getElementById('satcSub').textContent=
      state.color+' · '+state.size+' · '+state.tier+' hoodie'+(state.tier>1?'s':'');
    var n=28+(state.color.length*3)+(SIZES.indexOf(state.size)*5);
    document.getElementById('stockTxt').textContent='Only '+n+' left in '+state.color+' / '+state.size;
    document.getElementById('shipHead').textContent = tot>=FREE_SHIP
      ? 'Free tracked shipping — this order qualifies'
      : 'Add '+money(FREE_SHIP-tot)+' more for free shipping';
  };

  /* ---- video wall: Shopify Files CDN serves real video/mp4 ---- */
  (function(){
    var CDN = 'https://cdn.shopify.com/videos/c/vp/';
    var VIDS = [
      { h:'53774ce5119e4ec99cb2252a41bebc69', e:'94544129', poster:'mp-u1.png',      alt:'Grey tabby cat popping out of the front pouch' },
      { h:'a5c4fb56b265441eb5457c5fb6cc06a7', e:'94544130', poster:'mp-u3.png',      alt:'White cat resting in the front pouch' },
      { h:'2823f4f05d9f4838b08891c16dcc7e32', e:'94544131', poster:'mp-kitchen.png', alt:'Tuxedo cat in the pouch in a kitchen' },
      { h:'a0ca97c372f44b38ab30c8b12c009de5', e:'94544132', poster:'mp-d1.png',      alt:'Small Pomeranian dog in the front pouch' }
    ];
    var anchor = document.getElementById('reviews');
    if (!anchor) return;
    var sec = document.createElement('section');
    sec.className = 'band'; sec.id = 'vids';
    sec.innerHTML = '<div class="wrap"><div class="eyebrow">In motion</div>' +
      '<h2 class="sec">See it on.</h2>' +
      '<p class="lede">Cats and small dogs, in the pouch, in real rooms.</p>' +
      '<div class="vwall"></div></div>';
    anchor.parentNode.insertBefore(sec, anchor);
    var wall = sec.querySelector('.vwall');
    VIDS.forEach(function(v){
      var el = document.createElement('video');
      el.muted = true; el.loop = true; el.playsInline = true; el.preload = 'metadata';
      el.setAttribute('muted',''); el.setAttribute('playsinline','');
      el.setAttribute('aria-label', v.alt);
      if (window.MPASSET && MPASSET[v.poster]) el.poster = MPASSET[v.poster];
      var s = document.createElement('source');
      s.src = CDN + v.h + '/' + v.h + '.HD-720p-4.5Mbps-' + v.e + '.mp4';
      s.type = 'video/mp4';
      el.appendChild(s);
      wall.appendChild(el);
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(es){
        es.forEach(function(en){
          if (en.isIntersecting) en.target.play().catch(function(){});
          else en.target.pause();
        });
      }, { threshold: 0.25 });
      wall.querySelectorAll('video').forEach(function(v){ io.observe(v); });
    }
  })();

  buildBundle(); buildOffer(); render();
})();
